import Cookies from 'js-cookie'

const TokenKey = 'hmclient-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
const userInfoKey = 'userInfo'

export function getUserInfo() {
  const str = Cookies.get(userInfoKey)
  if (str && str.length > 0 && str !== 'undefined') {
    return JSON.parse(str)
  }
  return {}
}

export function setUserInfo(userinfo) {
  return Cookies.set(userInfoKey, userinfo)
}

export function removeUserInfo() {
  return Cookies.remove(userInfoKey)
}
const projectKey = 'project'

export function getProject() {
  return Cookies.get(projectKey)
}

export function setProject(project) {
  return Cookies.set(projectKey, project)
}

export function removeProject() {
  return Cookies.remove(projectKey)
}
